
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Thumbnail } from '@ecl/website-components';
import Col from '../../../components/Grid/Col';
import Row from '../../../components/Grid/Row';
import AccordionThumbnail from './accordion/ec_comp_accordion.svg';
import BlockquoteThumbnail from './blockquote/ec_comp_blockquotes.svg';
import ButtonThumbnail from './button/ec_comp_buttons.svg';
import CardThumbnail from './card/ec_comp_cards.svg';
import ExpandableThumbnail from './expandable/ec_comp_expandables.svg';
import FileThumbnail from './file/ec_comp_file.svg';
import IconThumbnail from './icon/ec_comp_icons.svg';
import ListThumbnail from './list/ec_comp_lists.svg';
import MessageThumbnail from './message/ec_comp_messages.svg';
import SMFThumbnail from './social-media-follow/ec_comp_social_follow.svg';
import SMSThumbnail from './social-media-share/ec_comp_social_share.svg';
import TagThumbnail from './tag/ec_comp_tags.svg';
import TimelineThumbnail from './timeline/ec_comp_timeline.svg';
import HeroBannerThumbnail from './banners/hero-banner/ec_comp_hero_banner.svg';
import PageBannerThumbnail from './banners/page-banner/ec_comp_page_banner.svg';
import RadioThumbnail from './forms/radio/ec_comp_radio.svg';
import SearchFormThumbnail from './forms/search-form/ec_comp_search.svg';
import SelectThumbnail from './forms/select/ec_comp_select.svg';
import TextAreaThumbnail from './forms/text-area/ec_comp_text_area.svg';
import TextFieldThumbnail from './forms/text-field/ec_comp_text_field.svg';
import GalleryThumbnail from './media/gallery/ec_comp_gallery.svg';
import MediaContainerThumbnail from './media/media-container/ec_comp_media_container.svg';
import BreadcrumbThumbnail from './navigation/breadcrumb/ec_comp_breadcrumb.svg';
import ContextualNavigationThumbnail from './navigation/contextual-navigation/ec_comp_contextual_navigation.svg';
import InpageNavigationThumbnail from './navigation/inpage-navigation/ec_comp_inpage-navigation.svg';
import LinkThumbnail from './navigation/link/ec_comp_links.svg';
import PaginationThumbnail from './navigation/pagination/ec_comp_pagination.svg';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Being the building blocks of the design system, components represent simple groupings of user interface elements (e.g. a label, an input field and a button to form a search field) through which we inform users of the expected interaction steps in order to help them achieve their goal.`}</p>
    <p>{`Every component is coded to serve a function and designed to solve a specific user interface problem. They can be used stand-alone or in conjunction with others as parts of a greater, harmonious whole.`}</p>
    <Row spacing="pv-m" mdxType="Row">
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={AccordionThumbnail} link="./accordion/usage/" title="Accordion" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={BlockquoteThumbnail} link="./blockquote/usage/" title="Blockquotes" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={ButtonThumbnail} link="./button/usage/" title="Buttons" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={CardThumbnail} link="./card/usage/" title="Card" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={ExpandableThumbnail} link="./expandable/usage/" title="Expandables" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={FileThumbnail} link="./file/usage/" title="File" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={IconThumbnail} link="./icon/usage/" title="Icons" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={ListThumbnail} link="./list/usage/" title="Lists" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={MessageThumbnail} link="./message/usage/" title="Messages" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={SMFThumbnail} link="./social-media-follow/usage/" title="Social media follow" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={SMSThumbnail} link="./social-media-share/usage/" title="Social media share" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={TagThumbnail} link="./tag/usage/" title="Tags" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={TimelineThumbnail} link="./timeline/usage/" title="Timeline" mdxType="Thumbnail" />
  </Col>
    </Row>
    <h2>{`Banners`}</h2>
    <Row spacing="pv-m" mdxType="Row">
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={HeroBannerThumbnail} link="./banners/hero-banner/usage/" title="Hero banner" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={PageBannerThumbnail} link="./banners/page-banner/usage/" title="Page banner" mdxType="Thumbnail" />
  </Col>
    </Row>
    <h2>{`Forms`}</h2>
    <Row spacing="pv-m" mdxType="Row">
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={RadioThumbnail} link="./forms/radio/usage/" title="Radio" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={SearchFormThumbnail} link="./forms/search-form/usage/" title="Search form" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={SelectThumbnail} link="./forms/select/usage/" title="Select" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={TextAreaThumbnail} link="./forms/text-area/usage/" title="Text area" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={TextFieldThumbnail} link="./forms/text-field/usage/" title="Text field" mdxType="Thumbnail" />
  </Col>
    </Row>
    <h2>{`Media`}</h2>
    <Row spacing="pv-m" mdxType="Row">
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={GalleryThumbnail} link="./media/gallery/usage/" title="Gallery" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={MediaContainerThumbnail} link="./media/media-container/usage/" title="Media container" mdxType="Thumbnail" />
  </Col>
    </Row>
    <h2>{`Navigation`}</h2>
    <Row spacing="pv-m" mdxType="Row">
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={BreadcrumbThumbnail} link="./navigation/breadcrumb/usage/" title="Breadcrumb" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={InpageNavigationThumbnail} link="./navigation/inpage-navigation/usage/" title="Inpage navigation" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={LinkThumbnail} link="./navigation/link/usage/" title="Links" mdxType="Thumbnail" />
  </Col>
  <Col col="12 sm-6 lg-4" spacing="pv-m" mdxType="Col">
    <Thumbnail image={PaginationThumbnail} link="./navigation/pagination/usage/" title="Pagination" mdxType="Thumbnail" />
  </Col>
    </Row>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;